import { IResponseQuoteForm } from "../../types";
import { goToResults } from "./goToResults";

export const responseSaveFormQuote = (response: IResponseQuoteForm) => {
  if (response.isCompleted && response.status) {
    goToResults();
  }
};
